// Web stand-in for the react-native APIs shared code uses: Platform.OS
// (notificationService push-token platform), Share (attendance CSV export) and
// Linking (utils/linking.js openExternalUrl, used by Partners).
import { takeFile } from "./fileSystem";

export const Platform = { OS: "web", select: (o) => o.web ?? o.default };

export const Share = {
  // attendanceExportService writes a CSV to a cache "file" and shares its uri:
  // on the web that becomes a browser download.
  async share({ url, title }) {
    const file = url ? takeFile(url) : null;
    if (!file) return { action: "dismissedAction" };
    const href = URL.createObjectURL(new Blob([file.contents], { type: "text/csv;charset=utf-8" }));
    const a = document.createElement("a");
    a.href = href;
    a.download = url.split("/").pop() || `${title || "export"}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(href), 1000);
    return { action: "sharedAction" };
  },
};

const isWebUrl = (url) => {
  try {
    const { protocol } = new URL(url);
    return protocol === "http:" || protocol === "https:" || protocol === "mailto:" || protocol === "tel:";
  } catch {
    return false;
  }
};

export const Linking = {
  // A new tab, never the app's own tab; noopener so the page cannot reach back.
  // Callers (utils/linking.js) already validate http/https; other schemes are refused here too.
  async openURL(url) {
    if (!isWebUrl(url)) throw new Error("Unsupported link");
    window.open(url, "_blank", "noopener,noreferrer");
    return true;
  },
  async canOpenURL(url) {
    return isWebUrl(url);
  },
};
